var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.667 10.436l.001.625a1 1 0 0 1 1.27 1.276l.618.001 1.034-1.034L2.695 9.41l-1.028 1.027zm7.447-7.434l1.89 1.889-5.471 5.47-1.894-1.894 5.475-5.465zM11.39.726l1.89 1.89c.52.52.52 1.364 0 1.884l-8.932 8.932a.92.92 0 0 1-.57.235H1A.666.666 0 0 1 .333 13v-2.777a.93.93 0 0 1 .235-.57L9.505.724c.52-.52 1.364-.52 1.885.001z","fill":"#3A66E5","fillRule":"evenodd"}));
}

Edit.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Edit;

Edit.default = Edit;
